import {StyleSheet} from 'react-native';

import {darkRed} from '/theme/color/secondary.color';

export const styles = StyleSheet.create({
  acceptTimeContainer: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
  },
  acceptTimeText: {
    color: darkRed,
    width: '100%',
    fontSize: 12,
    lineHeight: 14,
    fontWeight: '600',
  },
});
